<template>
    <section class="r-useraccount-container r-mt-20 r-mb-30">
        <div class="swiper">
          <div class="swiper-wrapper">
            <!-- Slides -->
              <a :href="slider.link" target="_blank" 
                rel="noreferrer noopener nofollow" 
                class=" swiper-slide r-sliders r-isFlex" 
                v-for="(slider, i) in sliders" :key="`slide-${i}`"
                >
                <img :src="slider.banner">
              </a>
          </div>
          <div class="swiper-pagination r-mt-20"></div>

        </div>
    </section>
</template>
<script>
// import { Hooper, Slide,  Pagination as HooperPagination } from 'hooper';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
// import 'hooper/dist/hooper.css';
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      sliders: 'sliderManage/getSliders'
    })
  },
  data: () => ({
    loading: true,
  }),
  mounted() {
    this.initData()
  },
  methods:{
    ...mapActions({
      getSlidersData: 'sliderManage/getSlidersData'
    }),
    async initData(){

      this.loading = true
      await this.getSlidersData()
      this.loading = false
      const swiper = new Swiper('.swiper', {
        modules: [Navigation, Pagination],
        // Optional parameters
        slidesPerView: 1,
        breakpoints: {
          800: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      })
      swiper.update()
    },
  }
}
</script>